import React from 'react';
import { NavLink } from 'react-router-dom';
import { buildSearchPath } from 'src/shared/sanitize';
import styled from 'styled-components/macro';

type Props = {
  autocompleteRef: React.RefObject<HTMLDivElement>;
  autoCompleteValues: string[];
  handleItemClick: () => void;
  keyDown: (e: React.KeyboardEvent<HTMLElement>) => void;
  selectedOption?: number;
  setSelectedOption: (index: number | undefined) => void;
  searchTerm: string;
};

export const SearchBoxAutocomplete = (props: Props) => {
  const {
    autocompleteRef,
    autoCompleteValues,
    keyDown,
    handleItemClick,
    searchTerm,
    selectedOption,
    setSelectedOption,
  } = props;

  const boldValue = (value: string) => {
    if (!searchTerm) {
      return value;
    }

    const escapedSearchTerm = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
    return value.replace(regex, '<b>$1</b>');
  };

  if (!autoCompleteValues.length) {
    return null;
  }

  return (
    <AutocompleteWrapper
      ref={autocompleteRef}
      className="search-autocomplete"
      onMouseOver={() => setSelectedOption(undefined)}
      onKeyDown={keyDown}
    >
      {autoCompleteValues.map((value, index) => (
        <AutocompleteItem
          key={value}
          to={buildSearchPath([value])}
          onClick={handleItemClick}
          className={`autocomplete-item ${selectedOption === index ? 'active-item' : ''}`}
        >
          <span dangerouslySetInnerHTML={{ __html: boldValue(value) }} />
        </AutocompleteItem>
      ))}
    </AutocompleteWrapper>
  );
};

const AutocompleteWrapper = styled.div`
  background-color: #fff;
  border: 1px solid ${(props) => props.theme.primary3};
  border-top: 0;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  left: 0;
  line-height: 1.33;
  position: absolute;
  top: 100%;
  width: 100%;
  z-index: 1;
  overflow: hidden;
`;

const AutocompleteItem = styled(NavLink)`
  color: #555;
  display: block;
  font-size: 0.85rem;
  padding: 5px 0 5px 58px;

  &:hover,
  &.active-item {
    color: #555;
    background-color: #e6e6e6;
    text-decoration: none;
  }
`;
